import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=0a4cae1c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4cae1c')) {
      api.createRecord('0a4cae1c', component.options)
    } else {
      api.reload('0a4cae1c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=0a4cae1c&", function () {
      api.rerender('0a4cae1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gdP56BNGYwNU/JS/comp/IncreaseNumber.vue"
export default component.exports